import React from "react";
import {
  AppBar,
  Toolbar,
  Box
} from "@mui/material";
import { Link, useNavigate } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import imgurl from "../assests/images/imgurl";

const WebHeader = () => {
  const gotTo = () => {
    let url = "https://aloxa.ai";
    window.open(url, "_blank");
  }

  return (
    <Box sx={{ flexGrow: 1 }}>
    <AppBar
      position="static"
      sx={{ backgroundColor: 'transparent', boxShadow: 'none', padding: '0 20px' }}
    >
      <Toolbar className="webHeadertoolbar">

        <Box sx={{ display: 'flex', alignItems: 'center', gap: '30px' }} className="webHeaderBox">
          <Link to="https://alopexia.com/" className="linkingIconHeader">
            <img src={imgurl.hairlossaiLogo} alt="New Logo" className="headerLogo mainlogo"/>
          </Link>

          <Box sx={{ display: 'flex', gap: '45px' }} className="webappNavbarlinks">
            <Link to="https://alopexia.com/" className="navItem active">Home</Link>
            <Link to="https://alopexia.com/pages/about-alopexia" className="navItem">About Alopexia</Link>
            <Link to="https://alopexia.com/pages/for-men" className="navItem">For Men</Link>
            <Link to="https://alopexia.com/pages/for-women" className="navItem">For Women</Link>
            <Link to={"/feedback"} className="navItem">Feedback</Link>
          </Box>
        </Box>
      </Toolbar>
    </AppBar>
  </Box>
  );
};

export default WebHeader;
